import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-71" data-mp="e3dirvkbfkrm">
      <div className="mx-auto max-w-6xl" data-id="element-72" data-mp="9mg9750515e">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-73" data-mp="58z49v7m0e9k">
          <div className="lg:col-span-7" data-id="element-74" data-mp="574iyfsfek4y">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-75" data-mp="3mguja2sg8vy9">الفرق مع التربية البدنية جاهزة™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-76" data-mp="3rhi7kgpamyos">
              من معلم مضغوط إلى <em className="text-red-700" data-id="element-77" data-mp="3diimtk4wj3xw">معلم واثق ومستعد.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-78" data-mp="3ig0uz8b3hf4u">
            تخيّل أن تبدأ أسبوعك وحصص التربية البدنية مرتبة مسبقًا. تعرف ماذا ستدرّس، ولديك خطة الحصة والألعاب وأوراق العمل وسلالم التقدير.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-79" data-mp="1jadqcw7ov7lo">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pl-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-r sm:border-t-0 sm:pr-8' : ''}`} data-id="element-80" data-mp="1f8si5o63nhht" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-81" data-mp="1o1dmw0cwbnnn">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-82" data-mp="10c1ev3tb1lmx">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-83" data-mp="wbrc000t7bca">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-84" data-mp="1aah7jb7zd2yj">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-85" data-mp="15be1pok6espi">قبل التربية البدنية جاهزة™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-86" data-mp="15dqqakkfw1bj">
              هل يبدو هذا مألوفًا؟
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-87" data-mp="2gphxn0abqqx7">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-88" data-mp="2oqpl2qfq2xai">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-89" data-mp="2suxa6oq3ef99" />
                  <span data-id="element-90" data-mp="2xpug3ms2s8hx">
                    <span className="block font-semibold text-slate-900/80" data-id="element-91" data-mp="32r0d3wsrqhx9">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-92" data-mp="2a231udmz5le0">
            <p className="text-sm font-semibold text-red-300" data-id="element-93" data-mp="2f15xj7h2ef9b">مع التربية البدنية جاهزة™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-94" data-mp="2jso183ah2txz">
              تحضير أقل، وتدريس أكثر.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-95" data-mp="1mc8si61v6eyi">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-96" data-mp="1ra0j8wqrvv14">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-97" data-mp="1jrki68wvitwb">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-98" data-mp="1erepqqis53d6" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-99" data-mp="10t7z9vg5u5nj">
          ركّز على طلابك في الملعب، لا على إعداد كل المواد بنفسك.
        </p>
      </div>
    </section>;
}